import { render, staticRenderFns } from "./DropZoneUpload.vue?vue&type=template&id=491fa842"
import script from "./DropZoneUpload.vue?vue&type=script&lang=js"
export * from "./DropZoneUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports